<template>
  <div id="study">
    <div class="home-head">
      <head-common :navList="navList1" :indexProp="indexProp1"></head-common>
    </div>
    <div class="study-content">
      <!--<img src="./../../static/pic/recommend_bg.jpg">-->
      <div class="study-content-recommend">
        <h2>{{studyContentRecommend.title}}</h2>
        <p>{{studyContentRecommend.content}}</p>
      </div>
      <div class="study-content-list">
        <div v-for="item in pageSize" class="study-content-item">
          <div v-if="item === 1">
            <div class="study-content-item-pic">
              <img v-bind:src="readingContent.pic">
            </div>
            <div class="study-content-item-p"><p>{{readingContent.content}}</p></div>
          </div>
          <div v-if="item === 2">
            <div class="study-content-item-pic">
              <img v-bind:src="readingContent2.pic">
            </div>
            <div class="study-content-item-p"><p>{{readingContent2.content}}</p></div>
          </div>
        </div>
      </div>
    </div>
    <div class="study-content-others">
      <ul>
        <li class="study-content-others-item" v-for="(item,index) in rightList">
          <a>{{item.title}}</a>
        </li>
      </ul>
    </div>
    <div class="home-footer">
      <footer-common></footer-common>
    </div>
  </div>
</template>

<script>
  import HeadCommon from './HeadCommon.vue'
  import SimpleClickEvent from './common/SimpleClickEvent.vue'
  import ArraysData from './common/ArraysData.vue'
  import ArticleList from './articles/ArticleList.vue'
  import FooterCommon from "./FooterCommon";

  export default {
    name: "StudyIndex",
    data: function () {
      return {
        simpleClickEventData:{
          paramCount:0,
          paramTitle:"雪域灰灰主页",
          aMoveActiveBg: "",
          aMoveActiveFont: "",
          onClickOne: false,
          onMoveOverOne: false
        },
        indexProp1: 2,
        navList1: [
          {routeName: "userLogin", navName: "登录", onClickOne: false},
          {routeName: "UserInfo", navName: "其他", onClickOne: false},
          {routeName: "Study", navName: "学习", onClickOne: false},
          {routeName: "home", navName: "首页", onClickOne: false}
        ],
        studyContentRecommend: {
          title: "在坚持在努力下下",
          content: "每一次大波折，都会倒下一批人，也站起来一批人"
        },
        readingContent: {
          title: "在坚持在努力下下",
          pic: "./../../static/pic/default-img.jpg",
          content: "陪伴是最长情的告白，相守是最温柔的承诺"
        },
        readingContent2: {
          title: "在坚持在努力下下",
          pic: "./../../static/pic/default-img.jpg",
          content: "看云是你，看行人也是你。那路过的风，有没有告诉你，我很想你"
        },
        pageSize: 2,
        rightList:[
          {title: "天道酬勤"},
          {title: "地道酬善"},
          {title: "人道酬诚"},
          {title: "商道酬信"},
          {title: "业道酬精"},
          {title: "家道酬和"}
        ],
        getPage: true
      }
    },
    methods: {
      clickMore: function () {
        /*todo 判断是否拿到页数*/
        this.getPage = false;
        //this.pageSize = 0;
      },
      clickMoreLeave: function () {
        this.getPage = true;
        console.log(2)
      }
    },
    components: {
      FooterCommon,
      HeadCommon,
      SimpleClickEvent,
      ArraysData,
      ArticleList
    }
  }
</script>

<style scoped>
  div, img, ul, li, p, label, input{margin: 0 auto; padding: 0; border: 0;}
  #study {
    width: 1000px;
    border-style: dotted;
    border-color: aqua;
    background: rgba(178, 255, 166, 0.44);
  }
  #study .study-content {
    position: relative;
    display: inline-block;
    width: 700px;
    height: 600px;
    float: left;
    border-style: solid;
    border-color: #797979;
    border-width: 0 2px 0 0;
  }
  #study .study-content .study-content-recommend {
    display: inline-block;
    width: 100%;
    height: 180px;
    margin: 5px 0;
    border-style: dotted;
    border-color: #797979;
    border-width: 0 0 2px 0;
    font-size: 1.2em;
    line-height: 1.8em;
    animation: border-color-move 4s infinite linear alternate;
  }
  #study .study-content .study-content-list {
    display: inline-block;
    width: 100%;
    height: 400px;
  }
  #study .study-content .study-content-list .study-content-item{
    display: inline-block;
    width: 100%;
    height: 200px;
    border-style: dotted;
    border-color: #797979;
    border-width: 0 0 1px 0;
  }
  #study .study-content .study-content-list .study-content-item .study-content-item-pic{
    display: inline-block;
    width: 180px;
    height: 180px;
    margin: 10px;
    float: left;
    border-style: dotted;
    border-color: #797979;
    border-width: 2px;
    animation: border-color-move 4s infinite linear alternate;
  }
  #study .study-content .study-content-list .study-content-item .study-content-item-pic img{
    width: 100%;
    max-height: 180px;
  }
  #study .study-content .study-content-list .study-content-item .study-content-item-p {
    position: relative;
    display: inline-block;
    width: 450px;
    height: 180px;
    margin: 10px;
    float: left;
    line-height: 190px;
    border-style: dotted;
    border-color: #797979;
    border-width: 2px;
    animation: border-color-move 4s infinite linear alternate;
  }
  #study .study-content .study-content-list .study-content-item .study-content-item-p p{
    position: relative;
    display: inline-block;
    width: 100%;
    font-size: 1.3em;
    line-height: 1.8em;
    border-style: dotted;
    border-color: #19fff8;
    border-width: 0;
  }
  #study .study-content-others {
    position: relative;
    display: inline-block;
    width: 250px;
    height: 500px;
    float: right;
    margin-top: 40px;
    padding: 24px;
    text-align: center;
  }
  #study .study-content-others .study-content-others-item {
    display: block;
    margin: 20px;
    border-style: solid;
    border-color: #189dce;
    border-width: 0 0 2px 0;
    line-height: 2.5em;
    font-size: 1.25em;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    animation: border-color-move 4s infinite linear alternate;
  }
  #study .home-footer {
    display: inline-block;
    width: 100%;
    height: 100px;
    border-style: solid;
    border-color: #797979;
    border-width: 2px 0;
  }
  /*规定动画*/
  @keyframes border-color-move {
    0% { border-color: #2fffbb;}
    25% { border-color: #ffdc51;}
    50% { border-color: #ff68e3;}
    75% { border-color: #2dccff;}
    100% { border-color: #34ff78;}
  }
</style>



// WEBPACK FOOTER //
// src/components/StudyIndex.vue